import React, {useLayoutEffect} from "react";
import {WhatIsKensuSection} from "./Sections/WhatIsKensuSection";
import {ArticlePreviewSection} from "./Sections/ArticlePreviewSection";
import {useLocation, useNavigate} from "react-router-dom";
import {FoundersSection} from "./Sections/FoundersSection";
import './Index.css';
import {App2} from "../App2";
import '../../Styles.css';
import './Article.css';
import {ActionButton} from "../../util/UI/ActionButton";
import {EmailSignup} from "./EmailSignup";

/**
 * This is the main homepage for kensu, it lives at the root path. It has
 * slight variations based on whether the user is logged in or not.
 */
export const Index = () => {

  const location = useLocation();

  useLayoutEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname]); // Trigger on route change

  return <App2>
    <TransformYourFutureHealth/>

    <video
        className={'HomePageVideo'}
        preload={'metadata'} autoPlay loop muted playsInline disablePictureInPicture>
      <source src={require('../../images/homepage_video.mp4')} type={'video/mp4'}/>
    </video>

    <WhatIsKensuSection/>
    <ArticlePreviewSection hasGoToWellnessLibraryButton={false}/>
    <FoundersSection/>
  </App2>;

}

export const TransformYourFutureHealth = () => {

  const navigate = useNavigate();

  return <div className={'AppSection BeigeSection'}>
    <div className={'AppSectionContent WaitlistWelcomeSection'}>

      <h1 style={{maxWidth: 600}}>
        Wellness, Reimagined
      </h1>

      <div className={'IntroCalloutText'} style={{maxWidth: 580}}>
        Blending Eastern wisdom with Western science to help transform your relationship with self-care and longevity
      </div>

      <div style={{width: 'min(100%, 700px)', padding: '50px 10px'}}>
      <EmailSignup/>
      </div>
      
      {/*<ActionButton orange extraStyles={{padding: '10px 70px', margin: 40}}*/}
      {/*              onClick={() => navigate('/search')}>*/}
      {/*  FIND A PRACTITIONER*/}
      {/*</ActionButton>*/}
    </div>
  </div>
}
